import { Box, Grid, styled, Typography } from '@mui/material';
import { useEffect, useMemo, useState } from 'react';
import { api } from '../../../api';
import { TableResponse } from '../../../schema/helper';
import { CCTVFilter, getCCTVSearchParams } from './filter';

interface SummaryCCTV {
  total: number;
  total_pass: number;
  total_not_pass: number;
  total_unknown: number;
}
type SummaryNumberInOutProps = CCTVFilter;

const SummaryNumberInOut: React.FC<SummaryNumberInOutProps> = ({
  filterID,
  filterName,
  filterGateIDList,
  filterCompanyIDList,
  filterPersonTypeIDList,
  filterStartDate,
  filterEndDate
}: SummaryNumberInOutProps) => {
  const [summary, setSummary] = useState<SummaryCCTV>({
    total: 0,
    total_pass: 0,
    total_not_pass: 0,
    total_unknown: 0
  });

  const summaryData = useMemo(
    () => [
      { title: 'แสกนทั้งหมด', amount: summary.total },
      { title: 'แสกนผ่าน', amount: summary.total_pass },
      { title: 'แสกนไม่ผ่าน', amount: summary.total_not_pass },
      { title: 'ไม่พบข้อมูลบุคคล (Unknown)', amount: summary.total_unknown }
    ],
    [summary]
  );

  useEffect(() => {
    // totals come from /scan-cctv, limit 1 to read only `total`
    const getTotal = (extraParams: Record<string, string> = {}) => {
      const searchParams = getCCTVSearchParams({
        filterID,
        filterName,
        filterGateIDList,
        filterCompanyIDList,
        filterPersonTypeIDList,
        filterStartDate,
        filterEndDate
      });
      Object.entries(extraParams).forEach(([key, value]) => searchParams.set(key, value));
      searchParams.set('limit', '1');
      return api
        .get<TableResponse>(`/scan-cctv`, { params: searchParams })
        .then((res) => res.data.total);
    };

    Promise.all([
      getTotal(),
      getTotal({ is_pass: 'true' }),
      getTotal({ is_pass: 'false' }),
      getTotal({ is_unknown: 'true' })
    ]).then(
      ([total, total_pass, total_not_pass, total_unknown]) => {
        setSummary({ total, total_pass, total_not_pass, total_unknown });
      }
    );
  }, [
    filterID,
    filterName,
    filterGateIDList,
    filterCompanyIDList,
    filterPersonTypeIDList,
    filterStartDate,
    filterEndDate
  ]);

  return (
    <Box>
      <Grid container>
        {summaryData.map((item, index) => (
          <SummaryAmountGrid item xs={3} key={`summary-box-${index}`}>
            <SummaryAmountBox>
              <Typography variant="caption">{item.title}</Typography>
              <Typography variant="h6">{item.amount}</Typography>
            </SummaryAmountBox>
          </SummaryAmountGrid>
        ))}
      </Grid>
    </Box>
  );
};

export default SummaryNumberInOut;

const SummaryAmountBox = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  padding: 16
}));

const SummaryAmountGrid = styled(Grid)({
  borderRight: '1px solid lightgray',
  '&:last-child': {
    borderRight: 'none'
  }
});
